const noop = () => {};

const statusPromises = new Map(); // candidate-list key -> Promise<PermissionStatus | null>

async function queryFirstSupported(names) {
    if (!navigator.permissions?.query) return null;
    for (const name of names) {
        try {
            return await navigator.permissions.query({ name });
        } catch {
            // Try the next candidate name.
        }
    }
    return null;
}

function statusOnce(names) {
    const key = names.join('|');
    if (!statusPromises.has(key)) statusPromises.set(key, queryFirstSupported(names));
    return statusPromises.get(key);
}

function toList(names) {
    return Array.isArray(names) ? names : [names];
}

// Resolves to 'granted' | 'prompt' | 'denied', or 'unknown' when detection is not available.
export async function getPermissionState(names) {
    const status = await statusOnce(toList(names));
    return status?.state || 'unknown';
}

// Invoke callback(state) whenever the permission changes. Returns an unsubscribe fn (a noop when
// detection is unavailable).
export function subscribePermission(names, callback) {
    if (typeof callback !== 'function') return noop;

    let status = null;
    let active = true;
    const handleChange = () => {
        if (active && status) callback(status.state);
    };

    statusOnce(toList(names)).then((resolved) => {
        if (!active || !resolved) return;
        status = resolved;
        status.addEventListener('change', handleChange);
    });

    return () => {
        active = false;
        if (status) status.removeEventListener('change', handleChange);
    };
}
